module.exports = __webpack_public_path__ + "static/media/ic-nutricao-min.39482d4f.svg";